import { render, staticRenderFns } from "./foor-style-6.vue?vue&type=template&id=4927f1fc&scoped=true"
import script from "./foor-style-6.vue?vue&type=script&lang=js"
export * from "./foor-style-6.vue?vue&type=script&lang=js"
import style0 from "./foor-style-6.vue?vue&type=style&index=0&id=4927f1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4927f1fc",
  null
  
)

export default component.exports